<template>
    <b-modal size="xl" button-size="sm" @hidden="close" @close="close" hide-footer v-model="showModal"
        :title="prefix + title">

        <LocalArmazenamentoList @close="localSelect" >
        </LocalArmazenamentoList>
    </b-modal>
</template>
<script>
import LocalArmazenamentoList from '@/modules/cadastros/local-armazenamento/LocalArmazenamentoList.vue';
export default {
    components: { LocalArmazenamentoList },

    props: {
        id: String,
        prefix: {
            type: String,
            default: "",
        }
    },

    mounted() {
    },

    data() {
        return {
            showModal: true,
            title: "Local Armazenamento",
        }
    },

    methods: {
        async show() {
            this.showModal = true;
        },

        async localSelect(item) {
            this.$emit("onSelect", item);
        },

        async close() {
            this.$emit("close");
        },
    }

};
</script>